import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { AiAppsPage } from "@/features/ai-apps";

export const Route = createFileRoute("/ai-apps/")({
  component: () => (
    <PermissionGuard module="ai_apps">
      <AiAppsPage />
    </PermissionGuard>
  ),
});
